// Quando a etiqueta entra sozinha no atendimento (mesmos ids do backend).
export const EVENTOS_ETIQUETA = [
  { id: "novo_candidato", rotulo: "Novo candidato (a assistente começou a atender)" },
  { id: "curriculo_recebido", rotulo: "Currículo recebido" },
  { id: "sem_curriculo", rotulo: "Não enviou currículo" },
  { id: "triagem_elegivel", rotulo: "Se encaixa na vaga (triagem ok)" },
  { id: "triagem_nao_elegivel", rotulo: "Não se encaixa na vaga" },
  { id: "entrevista_marcada", rotulo: "Entrevista marcada" },
  { id: "entrevista_cancelada", rotulo: "Entrevista cancelada / desmarcada" },
  { id: "compareceu", rotulo: "Compareceu à entrevista" },
  { id: "faltou", rotulo: "Faltou à entrevista" },
  { id: "transferido_rh", rotulo: "Passou para uma pessoa do RH" },
  { id: "desistiu", rotulo: "Candidato desistiu" },
  { id: "finalizado_pela_ia", rotulo: "Atendimento finalizado pela assistente" },
];

export const rotuloDoEvento = (id) => (EVENTOS_ETIQUETA.find((e) => e.id === id) || {}).rotulo || "";
